import * as Raven from 'raven-js';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { Http } from '@angular/http';
import { TranslateModule, TranslateLoader, TranslateStaticLoader } from 'ng2-translate';
import { BsDropdownModule, ModalModule, CollapseModule, TabsModule, AlertModule } from 'ng2-bootstrap';

//External BPA components
import { FilterPipe } from '../bpa_client_src/app/pipes/filter.pipe';
import { WrapperComponent } from '../bpa_client_src/app/components/wrapper/wrapper.component';
import { BreadcrumbsComponent } from '../bpa_client_src/app/components/breadcrumbs/breadcrumbs.component';

import { AppComponent } from './app.component';

import { DashboardPage } from './components/pages/dashboard/dashboard.component';
import { UsersPage } from './components/pages/user/user-list/user-list.component';

import {
    AuthRESTService
}
	from './components/services/rest/auth-rest.service';

import {
	CasBackendRESTService
}
	from './components/services/rest/cas-backend-rest.service';
	
import {NgxPaginationModule} from 'ngx-pagination';
import { DashboardCardWidget } from './components/widgets/dashboard/dashboard-card.component';
import { PanelWidget } from './components/widgets/panel/panel.component';
import { UserPage } from "./components/pages/user/user-edit/user-edit.component";
import { PageLayoutWidget } from "./components/widgets/page-layout/page-layout.component";
import { LoginPage } from "./components/pages/login/login.component";
import { RegisterPage } from "./components/pages/register/register.component";
import { HeaderWidget } from "./components/widgets/header/header.component";
import { LabelInputPairWidget } from "./components/widgets/label-input-pair/label-input-pair.component";
import { AlertBoxWidget } from "./components/widgets/alert-box/alert-box.component";
import { UserCreatePage } from "./components/pages/user/user-create/user-create.component";
import { FormPageLayoutWidget } from "./components/widgets/form-page-layout/form-page-layout.component";
import { FormPageWidget } from "./components/widgets/form-page/form-page.component";
import { LargePageLayoutWidget } from "./components/widgets/large-page-layout/large-page-layout.component";
import { LabelTextPairWidget } from "./components/widgets/label-text-pair/label-text-pair.component";
import { LabelSelectPairWidget } from "./components/widgets/label-select-pair/label-select-pair.component";
import { ElasticRESTService } from "./components/services/rest/elastic-rest.service";
import { PopoverModule } from 'ngx-bootstrap';
import { FormPageButtonBlockWidget } from "./components/widgets/form-page-button-block/form-page-button-block.component";
import { MomentModule } from 'angular2-moment';
import { DurationFormatterPipe } from './components/widgets/pipe-duration/duration-formatter.pipe';
import { AuthControllerService } from './services/auth-controller/auth-controller.service';
import { AuthGuard } from "./guards/auth.guard";
import { LoginPageLayoutWidget } from "./components/widgets/login-page-layout/login-page-layout.component";
import { Ng2CompleterModule } from "ng2-completer";
import { ModalWidget } from './components/widgets/modal/modal.component';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgUploaderModule } from 'ngx-uploader';
import {CookieService} from './components/services/cookie.service';

export class RavenErrorHandler implements ErrorHandler {
    handleError(err: any): void {
        Raven.captureException(err.originalError || err);
        throw err;
    }
}

let providers: [any] = [
    AuthControllerService,
	AuthRESTService,
	CasBackendRESTService,
    CookieService,
    AuthGuard,
    ElasticRESTService
]

const isLocalhost = location.hostname === 'localhost' || location.hostname === '127.0.0.1' || location.hostname === ''
if (!isLocalhost) {
    Raven
        .config('https://2c7ee078962d43a1a10ad9158fc1b86f@sentry.io/218403')
        .install();

    (<any>window).onunhandledrejection = function (evt) {
        Raven.captureException(evt)
    };

    (<any>window).onerror = function (evt) {
        Raven.captureException(evt)
    };

    providers.push({ provide: ErrorHandler, useClass: RavenErrorHandler })
}


@NgModule({
    declarations: [
        DashboardPage,
        UsersPage,
        UserPage,
        LoginPage,
        RegisterPage,
        UserCreatePage,
        AppComponent,
        WrapperComponent,
        BreadcrumbsComponent,

        HeaderWidget,
        ModalWidget,
        PageLayoutWidget,
        DashboardCardWidget,
        PanelWidget,
        LabelInputPairWidget,
        AlertBoxWidget,
        FormPageLayoutWidget,
        FormPageWidget,
        LargePageLayoutWidget,
        LabelSelectPairWidget,
        FormPageButtonBlockWidget,
        LoginPageLayoutWidget,
        LabelTextPairWidget,

        FilterPipe,

        DurationFormatterPipe,

    ],
    imports: [
		BrowserModule,
		NgxPaginationModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpModule,
		Ng2CompleterModule,
		NgUploaderModule,
        ToastrModule.forRoot(),
        PopoverModule.forRoot(),
        RouterModule.forRoot([
			{
				path: '',
				component: DashboardPage, canActivate: [AuthGuard]
			},
            {
                path: 'login',
                component: LoginPage
            },
            {
                path: 'register',
                component: RegisterPage
            },
            {
                path: 'dashboard',
                component: DashboardPage, canActivate: [AuthGuard]
            },
            {
                path: 'users',
                component: UsersPage, canActivate: [AuthGuard], data: {
					expectedRoles: ['sysadmin']
				}
            },
            {
                path: 'user/:id/edit',
                component: UserPage, canActivate: [AuthGuard], data: {
					expectedRoles: ['sysadmin']
				}
            },
            {
                path: 'user/create',
                component: UserCreatePage, canActivate: [AuthGuard], data: {
					expectedRoles: ['sysadmin']
				}
            }
        ]),
        TranslateModule.forRoot({
            provide: TranslateLoader,
            useFactory: httpFactory,
            deps: [Http]
        }),
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        CollapseModule.forRoot(),
        TabsModule.forRoot(),
        AlertModule.forRoot(),
        MomentModule,
    ],
    providers,
    bootstrap: [AppComponent],

})
export class AppModule {
}

export function httpFactory(http: Http) {
    return new TranslateStaticLoader(http, '/assets/i18n', '.json');
}


// WEBPACK FOOTER //
// ./src/app/app.module.ts